import { useMultivariateFlag } from './useMultivariateFlag';

/** How long a typed message waits for the next before it is read: `none`, `short` or `long`. */
export const ONBOARDING_TYPING_WAIT_FLAG = 'onboarding-typing-wait';

export interface TypingWait {
  /** How long a send waits for the next, from the last. */
  windowMs: number;
  /** The longest a send waits, however long text sits in the field. */
  capMs: number;
}

export type TypingWaitVariant = 'none' | 'short' | 'long';

export const TYPING_WAITS: Record<TypingWaitVariant, TypingWait> = {
  none: { windowMs: 0, capMs: 0 },
  short: { windowMs: 2000, capMs: 15_000 },
  long: { windowMs: 3000, capMs: 20_000 },
};

/** How long onboarding v4 holds a typed message for the next; not at all unless the flag says. */
export const useOnboardingTypingWait = () =>
  useMultivariateFlag<TypingWaitVariant, TypingWait>(
    ONBOARDING_TYPING_WAIT_FLAG,
    TYPING_WAITS,
    'none',
  );
